import React from "react";
import styled from "styled-components";
import { Colors } from "./styles/Colors";

const Wrapper = styled.div`
  position: relative;

  width: 25px;
  height: 25px;

  border: 1px solid ${Colors.webGrey};

  cursor: pointer;

  svg {
    position: absolute;

    top: 50%;
    left: 50%;

    transform: translate(-50%, -60%);
    cursor: pointer;
  }
`;

const StyledCheckbox = styled.input`
  position: absolute;

  width: 100%;
  height: 100%;

  margin: 0;

  opacity: 0;

  cursor: pointer;
`;

const Checkmark = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 7.07129L5.24264 11.3139L12.3137 4.24286" stroke="#2F3335" />
  </svg>
);

export default function Checkbox({ value, onChange, required, borderColor }) {
  return (
    <Wrapper style={{borderColor: `${borderColor}`}}>
      {value && <Checkmark />}
      <StyledCheckbox type="checkbox" value={value} onChange={onChange} required={required} />
    </Wrapper>
  );
}

Checkbox.defaultProps = {
  required: false,
	borderColor: `${Colors.webGrey}`
}